import React, { FC } from 'react';
import { Colors } from '../../../../styles/colors';

interface Props {
  color: string;
}
export const ProductIconGas: FC<Props> = ({ color = Colors.white }) => {
  return (
    <svg version="1.1" id="Ebene_1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
         viewBox="0 0 119 67.1" style={{ color }} xmlSpace="preserve" fill="currentColor">
      <g>
        <path d="M35,55.3c-2.3-1.2-3.3-3.9-2.5-6.3c0.5-1.5,1.6-2.7,3-3.4c2.2-1,6.9-0.8,7.6,3.7c0.2,1.9-0.3,3.8-1.4,5.3
          c1.7-0.3,9.9-4.5,9.9-12.4c0-8.8-9.5-17-14.2-20.2c0.2,2-0.3,3.9-1.4,5.6c-2.9,5.1-8.7,8.4-10.3,12.6C22.1,49.5,34.9,55.3,35,55.3"
        />
        <path d="M119,38c-0.4-15.6-13.4-28-29-27.6H51v-8C51,1.1,50,0,48.7,0c0,0,0,0-0.1,0H28c-1.3,0-2.4,1.1-2.4,2.3c0,0,0,0,0,0v8.2
          C10.1,12-1.4,25.8,0.1,41.4c1.3,14.3,13.2,25.4,27.6,25.7h63.6C107,66.7,119.4,53.7,119,38C119,38,119,38,119,38z M30.4,4.7h15.9
          v5.7H30.4V4.7z M107.8,55c-4.3,4.6-10.3,7.2-16.6,7.3H27.8c-13.1-0.3-23.4-11-23.2-24.1C4.8,25.6,15,15.3,27.7,15.1H90
          c13.1-0.4,23.9,9.9,24.3,23C114.5,44.4,112.1,50.5,107.8,55L107.8,55z"/>
      </g>
    </svg>
  );
}
